export const cleanEmailSubject = (subject: string): string => {
  return subject.replace(/^(FWD:|FW:|RE:)+\s*/gi, "").trim();
};
